import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-04/lesson-11/task-03";

const task: Slide = {
  titleHtml: `A membrane of mass M<sub>m</sub>, compliance C<sub>m</sub>,  resistance R<sub>m</sub> and surface area S<sub>d</sub> is connected to</br>a closed tube of the same cross-section at the back and to an open tube of acoustic mas</br>M<sub>at</sub> with a much larger section at the front. A force F is acting on the membrane. Which</br>diagram below corresponds to the equivalent electrical network of this system?`,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
